import dayjs from 'dayjs';
import { Formats } from '~/utils/time_utils';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { hrisManagedTooltip } from '~/utils/hris_provider_utils';

dayjs.extend(timezone);
dayjs.extend(utc);

export default {
  computed: {
    date() {
      if (this.numberOfHours > 24) {
        return [
          dayjs(this.start).format(Formats.date.shortMonth),
          dayjs(this.realEnd).format(Formats.date.shortMonth),
        ].join(' - ');
      }

      return dayjs(this.start).format(Formats.date.shortMonth);
    },
    numberOfHours() {
      // need to add 1s to end timestamp because for all day events end time returned is
      // 2022-12-20T23:59:59Z which gets rounded down and causes displaying of
      // 23h instead of 1d on the calendar
      return dayjs(this.realEnd).add(1, 'second').diff(this.start, 'hours');
    },
    numberOfDays() {
      const endTs = this.type === 'Time off request' ? dayjs(this.realEnd).add(1, 'day') : dayjs(this.realEnd);

      return endTs.diff(this.start, 'days');
    },
    dayText() {
      return this.numberOfDays === 1 ? 'day' : 'days';
    },
    hourText() {
      return this.numberOfHours === 1 ? 'hour' : 'hours';
    },
    duration() {
      if (!this.realEnd) {
        return '1 day';
      }

      if (this.numberOfHours >= 24) {
        return [this.numberOfDays, this.dayText].join(' ');
      }

      return [this.numberOfHours, this.hourText].join(' ');
    },
    type() {
      return this.event.extendedProps.type;
    },
    avatar() {
      return this.event.extendedProps.avatar;
    },
    resourceId() {
      return Number(this.event.extendedProps.resourceId ?? this.event._def.resourceIds[0]);
    },
    userRealName() {
      return this.event.extendedProps.userRealName;
    },
    start() {
      return this.event.start;
    },
    end() {
      return this.event.end;
    },
    realEnd() {
      return this.event.extendedProps.realEnd;
    },
    style() {
      return this.event.style;
    },
    allDay() {
      return this.event.allDay;
    },
    unapprovedTimeOff() {
      return this.event.classNames.includes('is-not-approved');
    },
    defaultStyle() {
      if (this.unapprovedTimeOff) {
        return;
      }

      const { backgroundColor, borderColor, textColor } = this.event;

      return { backgroundColor, borderColor, color: textColor };
    },
    shiftSpillover() {
      const start = dayjs.utc(this.start).tz(this.eventTimeZone);
      const end = dayjs.utc(this.realEnd).tz(this.eventTimeZone);

      return this.type === 'Shift' && end.isAfter(start, 'day');
    },
    eventTimeZone() {
      return this.timeZone || 'UTC';
    },
    importedIntegrationType() {
      return this.event.extendedProps.integration_type || 'bamboo_hr';
    },
    showImportedTimeOffBadge() {
      return this.type === 'Time off request' && this.event.extendedProps.imported;
    },
    hrisImportedManagedTooltip() {
      return hrisManagedTooltip(this.importedIntegrationType);
    },
    eventTooltip() {
      if (!this.showImportedTimeOffBadge) {
        return null;
      }

      return { placement: 'bottom', title: this.hrisImportedManagedTooltip };
    },
    hrisImportedEventAriaLabel() {
      return this.showImportedTimeOffBadge ? this.hrisImportedManagedTooltip : null;
    },
  },
};
